import React from 'react';

type Props = {
  isLiked?: boolean;
  fillColor?: string;
  width?: number;
  height?: number;
};

const LikeIcon = ({ isLiked = false, fillColor = '#ff9f1c', width = 24, height = 24 }: Props) => {
  if (isLiked) {
    return (
      <svg width={width} height={height} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
          d="M4 8.5H6.5V20.5H4C3.2 20.5 2.5 19.8 2.5 19V10C2.5 9.2 3.2 8.5 4 8.5ZM13.9473 2.10742C14.1842 2.07886 14.4122 2.12094 14.6426 2.24219C14.8731 2.36356 15.028 2.52371 15.1279 2.72363C15.2007 2.8692 15.2289 3.00893 15.2168 3.15234L15.1914 3.29785L15.1895 3.30566L14.0645 7.88086L13.9121 8.5H21C21.3921 8.5 21.7343 8.64058 22.0469 8.95312C22.3594 9.26566 22.5 9.60796 22.5 10V12C22.5 12.0693 22.49 12.1534 22.4648 12.2539C22.4354 12.3716 22.405 12.4813 22.376 12.584L19.3936 19.5947C19.2876 19.83 19.1061 20.0452 18.8223 20.2344C18.5462 20.4183 18.2749 20.5 18 20.5H7.5V8.20801L13.3525 2.40527L13.3535 2.40332C13.5269 2.23 13.7202 2.1355 13.9473 2.10742Z"
          fill={fillColor}
        />
      </svg>
    );
  }

  return (
    <svg width={width} height={height} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M4 8.5H6.5V9.5H3.5V19.5H6.5V20.5H4C3.58355 20.5 3.23962 20.3578 2.94141 20.0596C2.64235 19.7605 2.50002 19.4162 2.5 19V10C2.5 9.58381 2.64237 9.23949 2.94141 8.94043C3.23963 8.64221 3.58354 8.5 4 8.5ZM13.9473 2.10742C14.1842 2.07886 14.4122 2.12094 14.6426 2.24219C14.8731 2.36356 15.028 2.52371 15.1279 2.72363C15.2007 2.8692 15.2289 3.00893 15.2168 3.15234L15.1914 3.29785L15.1895 3.30566L14.0645 7.88086L13.9121 8.5H21C21.3921 8.5 21.7343 8.64058 22.0469 8.95312C22.3594 9.26566 22.5 9.60796 22.5 10V12C22.5 12.0693 22.49 12.1534 22.4648 12.2539C22.4354 12.3716 22.405 12.4813 22.376 12.584L19.3936 19.5947C19.2876 19.83 19.1061 20.0452 18.8223 20.2344C18.5462 20.4183 18.2749 20.5 18 20.5H7.5V8.20801L13.3525 2.40527L13.3535 2.40332C13.5269 2.23 13.7202 2.1355 13.9473 2.10742ZM12.9961 4.14648L8.5 8.64258V19.5H18.3301L18.46 19.1973L21.46 12.1973L21.5 12.1025V9.5H12.6377L13.8359 4.61914L14.2627 2.88086L12.9961 4.14648Z"
        fill="white"
      />
    </svg>
  );
};

export default LikeIcon;
